import React from "react";
import { Box, Button, Grid2, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material";
import { tokens } from "../theme";
import { ArrowForward } from "@mui/icons-material";

const ProjectBox = ({
  title,
  link,
  setSelected,
  date,
  description,
  img,
  selected,
  tags = [],
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  return (
    <Grid2 xs={12}>
      <Box
        m="20px"
        p="20px"
        sx={{
          border: "1px solid #E0E0E0",
          borderRadius: "16px",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
          backgroundColor: " ",
          transition: "all 0.3s ease-in-out",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          gap: "10px",
          cursor: "pointer",
// 
          ...(selected === title && {
            transition: "transform 0.2s ease",
            "&:hover [data-arrow]": {
              transform: "translateX(7px)",
            },
          }),
          //
          ...(selected !== title && {
            "&:hover ": {
              transform: "translateY(-5px)",
              boxShadow: "0px 8px 18px rgba(0, 0, 0, 0.12)",
            },
          }),
        }}
        onClick={() => {
          selected === title ? navigate(link) : setSelected(title);
        }}
      >
        {/* Job Title */}
        <Box
          display="flex"
          justifyContent="space-between"
          color={colors.primary[300]}
        >
          <Typography
            variant="h5"
            fontWeight="bold"
            color={colors.primary[100]}
          >
            {title}
          </Typography>
          <Typography variant="subtitle1">{date}</Typography>
        </Box>
        {selected === title && (
          <Box
            sx={{
              mt: 1,
              height: selected === title ? "auto" : 0,
              opacity: selected === title ? 1 : 0,
              transform:
                selected === title ? "translateY(0)" : "translateY(-10px)",
              overflow: "hidden",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            }}
            data-visible={true}
          >
            <img src={img} alt="" width="100%" />
          </Box>
        )}
        {/* Description */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography color={colors.primary[200]}>{description}</Typography>
          {selected === title && (
            <Button
              startIcon={
                <ArrowForward
                  data-arrow
                  sx={{
                    color: "colors.primary[200]",
                  }}
                />
              }
              onClick={() => navigate(link)}
              sx={{
                fontWeight: "bold",
                backgroundColor: "transparent",
              }}
            ></Button>
          )}
        </Box>

        {tags.length > 0 && (
          <Box mt="10px" display="flex" flexWrap="wrap" gap="8px">
            {tags.map((tag, index) => (
              <Box
                key={index}
                sx={{
                  px: "10px",
                  py: "4px",
                  borderRadius: "12px",
                  backgroundColor: "white",
                  color: colors.primary[900],
                  fontSize: "0.8rem",
                  fontWeight: "500",
                }}
              >
                {tag}
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Grid2>
  );
};

export default ProjectBox;
